import React from 'react';

import styles from 'components/prequalification/EntryFormResult/EntryFormResult.module.scss';

const RejectedIntermediary = () => {
  return (
    <div>
      <p className={styles.text}>Thank you for your submission.</p>
    </div>
  );
};

export default RejectedIntermediary;
